import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { ClientService } from '../../../services/client.service';
import { ToastComponent } from '../../toast/toast.component';
import { Client } from '../../models/client.model';
import { categories, clusters, ee, urlRegexp } from '../../constants';
import { setClassInvalidTpl } from '../../functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-edit-client-modal',
  templateUrl: './edit-client-modal.component.html',
  standalone: false
})
export class EditClientModalComponent implements OnInit, OnDestroy {
  toast = inject(ToastComponent);
  private clientService = inject(ClientService);


  @Input() client: Client;
  @Input() field = '';

  clusters = clusters;
  categories = categories;
  urlRegexp = urlRegexp;
  setClassInvalidTpl = setClassInvalidTpl;

  ngOnInit(): void {
    // This is executed N+1 times, to fix eventually
    ee.on('showEditClientModal', (field: string) => this.field = field);
  }

  ngOnDestroy(): void {
    ee.off('showEditClientModal', () => {});
  }

  updateClient(field: string): void {
    const client: Client = {
      _id: this.client._id,
      [field]: this.client[field]
    };
    this.clientService.update(client)
      .pipe(finalize(() => ee.emit('getClient')))
      .subscribe({
        next: res => this.toast.setMessage('Client updated successfully', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
